"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Indexed2dCappedLineValueProvider = void 0;
/**
 * @internal
 */
class Indexed2dCappedLineValueProvider {
    constructor() {
        this.fallbackColor = 0;
    }
    update(entity, screenTransform, sizeTransform, userTransform) {
        this.fallbackColor = entity.graphicsSettings.pointDisplay.packedColor;
        this.screenTransform = screenTransform;
        this.sizeTransform = sizeTransform;
        this.userTransform = userTransform;
    }
    getSize(size) {
        return this.sizeTransform.getVec2MultiplyX(size) * 0.5;
    }
    setPosition(toSet, x, y) {
        toSet.update(this.screenTransform.getVec3MultiplyX(this.userTransform.forwardX(x)), this.screenTransform.getVec3MultiplyY(this.userTransform.forwardY(y)));
    }
}
exports.Indexed2dCappedLineValueProvider = Indexed2dCappedLineValueProvider;
//# sourceMappingURL=indexed2d-capped-line-value-provider.js.map